import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  CoreLink,
} from '@uncinc/react-drupal-core';

import './style.scss';

const SelectedEntities = ({ id, type, link, entities, title, context }) => {
  const { t } = useTranslation();

  return (
    <div id={id} className="ParagraphSelectedEntities">
      <Container>
        <div className="row">
          <div className="col-12">
            <CoreLink to={link} className="SelectedReadmore Paragraph__readmore">
              {t('general.view_all')} {t(`entities.${type}`).toLowerCase()}
              <span className="icon icon-arrow-right icon-variant-2" />
            </CoreLink>
            <h2>{title}</h2>
          </div>
        </div>
        <div className="row rendered_content">
          {entities.map((record) => {
            if (!record) {
              return;
            }

            let ent = record.get('entity');
            if (!ent) {
              ent = record;
            }
            const id = ent.getIn(['nid', 0, 'value']);
            const uuid = ent.getIn(['uuid', 0, 'value']);
            return (
              <div key={uuid} className="col-12 col-md-6 col-lg-4">
                <Node
                  id={id}
                  entity={ent}
                  viewMode="teaser"
                  context={context}
                  large={false}
                />
              </div>
            );
          })}
        </div>
        <div className="row Paragraph__readmore_mb">
          <div className="col-12">
            <CoreLink to={link} className="SelectedReadmore">
              {t('general.view_all')} {t('entities.articles').toLowerCase()}
              <span className="icon icon-arrow-right icon-variant-2" />
            </CoreLink>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SelectedEntities;
